export default __webpack_public_path__ + "static/media/sign-up.5269975d.png";